import { Button, DataTableController } from 'components/common'
import {
  BundleProductFilterForm,
  BundleProductImportModal,
  BundleProductTable,
  bundleProductColumns,
} from 'components/bundleProduct'
import ActiveFilterChip from 'components/common/activeFilterChip'
import { FILTER_FIELD_BUNDLE_PRODUCT } from 'components/bundleProduct/bundleProductFilterForm'
import { ImportIcon, PlusIcon } from 'components/icons'
import { usePageAccess, useQuery } from 'hooks'
import { useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { downloadBundleProducts } from 'utils/api/bundleProductApi'
import { PAGE_ADD_PRODUCT } from 'utils/constants'
import { filterEmptyValues } from 'utils/helpers'

const BundleProductList = () => {
  const { isEditor } = usePageAccess()
  const navigate = useNavigate()
  const { getQuery } = useQuery()
  const [showFilter, setShowFilter] = useState(false)
  const [selectedColumns, setSelectedColumns] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [isImportModalOpen, setIsImportModalOpen] = useState(false)

  const toggleFilterForm = () => {
    setShowFilter(!showFilter)
  }

  const handleExport = async () => {
    const filters = getQuery(FILTER_FIELD_BUNDLE_PRODUCT)
    const bundleProductFilter = filters ? filterEmptyValues(filters) : {}

    const loadingToast = toast.loading('Loading...', { duration: Infinity })

    try {
      await downloadBundleProducts(bundleProductFilter)
      toast.success('File will be sent to you in email!', {
        id: loadingToast,
        duration: 3000,
      })
    } catch {
      toast.error('Failed to export Bundle Products.', {
        id: loadingToast,
        duration: 3000,
      })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Bundle Products</title>
      </Helmet>

      {isEditor && (
        <div className="mb-5 flex gap-3">
          <Button
            buttonText="Create Bundle Product"
            icon={<PlusIcon />}
            onClick={() => navigate(PAGE_ADD_PRODUCT.path)}
          />
        </div>
      )}

      <BundleProductImportModal
        isOpen={isImportModalOpen}
        closeModal={() => setIsImportModalOpen(false)}
      />

      <DataTableController
        isEditor={isEditor}
        columns={bundleProductColumns}
        handleFilter={toggleFilterForm}
        showFilter={showFilter}
        handleExport={handleExport}
        activeColumnKey="bundleProduct"
        placeholder="Search by barcode, description or online description"
        defaultSelectedColumns={selectedColumns}
        loading={loading}
        extraActions={
          <Button
            type="button"
            buttonText="Import"
            variant="custom"
            iconClassName="!h-5 !w-5 text-dataTableIcon"
            icon={<ImportIcon />}
            className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
            onClick={() => setIsImportModalOpen(true)}
            disabled={loading}
          />
        }
      />

      {!showFilter && (
        <ActiveFilterChip filterKey={FILTER_FIELD_BUNDLE_PRODUCT} />
      )}

      {showFilter ? (
        <BundleProductFilterForm toggleFilterForm={toggleFilterForm} />
      ) : (
        <BundleProductTable
          setSelectedColumns={setSelectedColumns}
          isEditor={isEditor}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </>
  )
}

export default BundleProductList
